import type { DateLine } from '@/journey/_lib/compose-stand'

// Date heading at the top of the center panel. Reads as a chapter rule in a
// Penguin Classic — date set in the running serif, flanked by a small ink-red
// marginalia mark on the left (the teacher's pen touching the page) and a
// hairline rule running to the right margin. No greeting, no day-name.
export function DatedHeading({ dateLine }: { dateLine: DateLine }) {
    return (
        <header className="mb-10 flex items-baseline gap-3 sm:mb-12 lg:mb-14">
            {/* reason: vermilion #1 — the dated marginal mark, ink-red register
                from spine §6.5.4. A single small glyph beside the date carries
                the teacher-pen reading without painting any rule weight in vermilion. */}
            <span
                aria-hidden
                className="translate-y-[-0.05em] font-serif text-base leading-none text-action select-none"
            >
                ¶
            </span>
            <h2 className="font-serif text-xl tracking-tight text-ink sm:text-2xl">
                {dateLine.primary}
            </h2>
            <span aria-hidden className="h-px flex-1 rule-baseline bg-rule" />
        </header>
    )
}
